import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import EquipContainingLogForm from "./EquipContainingLogForm";

const EditEquipContainingLog = () => {
  const { id } = useParams(); // ods_id
  const navigate = useNavigate();
  const [details, setDetails] = useState(null);

  useEffect(() => {
    const fd = new FormData();
    fd.append("ods_id", id);

    post(ApiURL.ods_listing_details, fd).then((res) => {
      if (res?.status === true) setDetails(res.data);
    });
  }, [id]);

  if (!details) return <h3>Loading...</h3>;

  const handleSuccess = () => {
    navigate("/equip-containing-log");
  };

  return (
    <>
      <h2>Edit Equip Containing Log</h2>
      <EquipContainingLogForm
        mode="edit"
        odsId={id}
        equipmentDetails={details.equipment}
        onSaveSuccess={handleSuccess}
      />
    </>
  );
};

export default EditEquipContainingLog;
